import { Box, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import { StyledExpDate } from './index.style';

const ExpDate = ({ packageExpiryDate }) => {
  const { t } = useTranslation();
  const hasExpired =
    packageExpiryDate && moment(packageExpiryDate).isBefore(moment());
  const formattedExpDate =
    moment(packageExpiryDate).format('DD/MM/YYYY - HH:mm');

  return (
    <StyledExpDate>
      <Box className="exp-date-container">
        <Typography className="label">{t('expiryDate')}</Typography>
        {!!hasExpired && (
          <Box className="expired-container">
            <Typography className="expired-label">{t('expiredNew')}</Typography>
          </Box>
        )}
      </Box>
      <Typography className="content">
        {packageExpiryDate ? formattedExpDate : t('endless')}
      </Typography>
    </StyledExpDate>
  );
};
export default ExpDate;
